import React, { ReactElement, ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { selectHasIncompleteFertilizerEvents } from './selectors';

interface Props {
    fallback?: ReactElement | ReactNode;
    children: ReactElement | ReactNode;
}

export default function FertilizerEventHasIncompleteEventsGate(
    props: Props
): ReactElement | null {
    const { children, fallback } = props;

    const hasIncompleteFertilizerEvents = useSelector(
        selectHasIncompleteFertilizerEvents
    );

    if (hasIncompleteFertilizerEvents) {
        return <React.Fragment>{children}</React.Fragment>;
    }

    if (fallback) {
        return <React.Fragment>{fallback}</React.Fragment>;
    }

    return null;
}
